import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';
export type MarketSettingsCentralMappingRouteModel = {
  breakdowns: Services['central-mapping']['getBreakdownsTask'];
};

export default class MarketSettingsCentralMappingRoute extends Route {
  @service declare access: Services['access'];
  @service declare centralMapping: Services['central-mapping'];
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    if (this.access.hasCentralMapping) {
      if (transition.to.name === 'market.settings.central-mapping.index') {
        this.router.transitionTo('market.settings.central-mapping.menu');
      }

      return;
    }

    this.router.transitionTo('market.settings');
  }

  // eslint-disable-next-line @typescript-eslint/require-await
  async model(): Promise<MarketSettingsCentralMappingRouteModel> {
    const model: MarketSettingsCentralMappingRouteModel = {
      breakdowns: this.centralMapping.getBreakdownsTask,
    };

    void model.breakdowns.perform();

    return model;
  }
}
